const QuestionnairesList = () =>
  import(
    /* webpackChunkName: "QuestionnairesList" */ "@/components/rapsotec/questionnaire/QuestionnairesList.vue"
  );

const QuestionnaireCreate = () =>
  import(
    /* webpackChunkName: "QuestionnaireCreate" */ "@/components/rapsotec/questionnaire/QuestionnaireCreate.vue"
  );

export default [
  {
    path: "",
    name: "questionnairesList",
    component: QuestionnairesList,
  },
  {
    path: "edit/:uuid?",
    name: "questionnairesCreate",
    component: QuestionnaireCreate,
  },
];
